import React from 'react';
import { graphql } from 'gatsby';
import { Timeline as TimelineComponent } from '../../../timeline/timeline';

export const Timeline = ({ data, ...rest }) => (
  <TimelineComponent {...data} {...rest} />
);

export const TimelineQuery = graphql`
  fragment Timeline on UMBRACO_TimelineComponentType {
    items {
      heading
      subheading
      description
      link {
        ...Link
      }
      image {
        image {
          ...TimelineImage
        }
      }
    }
  }
`;
